import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M11.88 12.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M10.38 20.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M23.12 12.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.11 6.75C22.65 4.33 19.42 3 15.99 3h-.13c-3.05.03-6 1.14-8.32 3.13a13 13 0 0 0-4.37 7.74c-.5 3.01.08 6.11 1.63 8.74s3.99 4.63 6.86 5.65c.43.16.89.24 1.35.24a4.2 4.2 0 0 0 2.3-.73c.52-.37.95-.86 1.24-1.43s.45-1.21.44-1.84v-.49c0-.26.05-.52.15-.76s.25-.46.43-.65.41-.33.65-.43c.25-.1.53-.15.77-.15h5.78c.9 0 1.79-.31 2.49-.87s1.2-1.35 1.41-2.23c.22-.99.33-2 .33-3.01-.03-3.46-1.41-6.7-3.89-9.15zm1.62 11.71c-.1.44-.35.83-.7 1.11s-.79.43-1.25.43h-5.79c-.52 0-1.03.1-1.52.3s-.93.49-1.3.87-.67.81-.87 1.3S15 23.48 15 24v.49c0 .32-.07.64-.22.92s-.36.53-.62.71-.56.3-.88.34c-.31.04-.64 0-.95-.1-2.43-.86-4.49-2.56-5.81-4.78-1.31-2.22-1.8-4.85-1.38-7.39.42-2.55 1.74-4.87 3.69-6.55 1.96-1.68 4.46-2.62 7.04-2.65h.11c2.9 0 5.63 1.12 7.72 3.17 2.1 2.07 3.27 4.81 3.29 7.73 0 .85-.08 1.71-.27 2.54z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPalette = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPalette);
export default Memo;
